import { combineReducers } from "redux";
import auth from "./auth";
import base from "./base";
import booking from "./booking";
import locale from "./locale/localeSlice";
import notifications from "./notifications/notifSlice";
import parc from "./parc/parcSlice";
import theme from "./theme/themeSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    booking,
    parc,
    base,
    locale,
    notifications,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
